import axios from "axios";
// import { AuthContext } from "../hooks/AuthContext";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("🔐 Token expirado");
      window.dispatchEvent(new CustomEvent("tokenExpired")); // El App.js escucha esto
    }
    return Promise.reject(error);
  }
);

